import { render } from "./CompSimpleKeyboard.vue?vue&type=template&id=1c48bf21"
import script from "./CompSimpleKeyboard.vue?vue&type=script&lang=js"
export * from "./CompSimpleKeyboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__